// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLogoPage-Footer_cls1__E6evg","cls2":"VeloLogoPage-Footer_cls2__y83QW VeloLogoPage-Footer_cls1__E6evg"};